module.exports = __webpack_public_path__ + "static/media/Dranzleyder.231ad95f.jpg";